export default __webpack_public_path__ + "static/media/Image (3).80ad37b6.png";